import { styled, TableRow } from "@mui/material";

// export const StyledTableRow = withStyles((theme: Theme) =>
//     createStyles({
//         root: {
//             '&:nth-of-type(odd)': {
//                 backgroundColor: theme.palette.info.light,
//             },
//             '&:hover': {
//                 backgroundColor: `${theme.palette.action.hover}`,
//             }
//         }
//     }),
// )(TableRow);

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.info.light,
    },
    '&:hover': {
        backgroundColor: theme.palette.action.hover,
    },
}));

export default StyledTableRow;
